<mat-icon *ngIf="isLoading">
	<mat-spinner diameter="20"> </mat-spinner>
</mat-icon>

<div *ngIf="!isLoading">
	<mat-card-header>
		<mat-card-title class="h5">
			Editing {{workflow.NAME}}
		</mat-card-title>
	</mat-card-header>
	<mat-divider> </mat-divider>

	<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>


	<div class="margin-top-md">
		<mat-tab-group id="tab-group" animationDuration="0ms" [(selectedIndex)]="selectedIndex">
			<mat-tab [label]="'Edit'">
				<edit-workflow-information [workflow]="workflow"></edit-workflow-information>
			</mat-tab>
			<mat-tab [label]="'States'">
				<edit-workflow-states [workflow]="workflow"></edit-workflow-states>
			</mat-tab>
			<mat-tab [label]="'Transitions'">
				<edit-workflow-transitions [workflow]="workflow"></edit-workflow-transitions>
			</mat-tab>
		</mat-tab-group>
	</div>
</div>